import { IGallery } from "@types";
import { BaseAPI } from "@utils";

class GalleryApi extends BaseAPI<IGallery> {}

export const galleryApi = new GalleryApi("/api/v1/gallery");
